import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { CopyIcon } from "@icons";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { SendingDomainRow } from "../sendingDomainsViewConfig";

export const DomainCell = memo(
    ({ row }: CellContext<ViewTableFeatures, SendingDomainRow, string>) => (
        <ViewTableCell>
            <CopyOnClick value={row.original.domain} className="cursor-pointer">
                {row.original.domain} <CopyIcon className="ml-1" />
            </CopyOnClick>
        </ViewTableCell>
    ),
);
